export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('Accordion', () => {
        const changeDesktopClasses = (childrens) => {
          for (const children of childrens) {
            if (children.classList.contains('md:block')) {
              children.classList.remove('md:block');
              continue;
            }

            children.classList.add('md:block');
          }
        };
        const changeMobileClasses = (children) => {
          if (!children.classList.contains('hidden')) {
            children.classList.remove('flex');
            children.classList.add('hidden');
            return;
          }

          children.classList.remove('hidden');
          children.classList.add('flex');
        };
        const changeArrowClasses = (arrow) => {
          if (arrow.classList.contains('rotate-180')) {
            arrow.classList.remove('rotate-180');
            return;
          }
          arrow.classList.add('rotate-180');
        };
        return {
          toggleAccordion(id) {
            const container = document.getElementById(id);
            const containerTitle = container.querySelectorAll('.svg_arrow')[0];
            const containerMobile = container.querySelectorAll(
              '.information_mobile',
            )[0];
            const containerDesktop = container.querySelectorAll(
              '.information_desktop',
            );

            if (containerTitle) {
              changeArrowClasses(containerTitle);
            }
            if (containerDesktop.length) {
              changeDesktopClasses(containerDesktop);
            }

            if (containerMobile) {
              changeMobileClasses(containerMobile);
            }
          },
        };
      });
    });
  },
};
